/*eslint-disable */

import _ from "lodash";

require("../node_modules/alertifyjs/build/css/alertify.min.css");
require("../node_modules/alertifyjs/build/css/themes/default.min.css");

import Vue       from "vue";
import Vuex      from "vuex";

Vue.use(Vuex);
import store     from "./store";
import is        from "is_js";
import moment    from "moment";
import Cookies   from "js-cookie";
import Inputmask from "inputmask";
import alertify  from "alertifyjs";

moment.locale("ru");

window.Cookies=Cookies;
window.Vue    =Vue;
window.is     =is;
window.moment =moment;

function XpageInit()
    {
        var self         =this;
        this.ajaxSettings={};
        this.ajaxTimeout;

        this.init=function()
            {
                this.resetAjaxSettings();
            };

        this.resetAjaxSettings=function()
            {
                this.ajaxSettings={
                    ajaxData  : {
                        data : [],
                    },
                    onSuccess : [],
                    onError   : [],
                };
            };

        this.ajax=function( settings )
            {
                settings=settings || {};
                this.ajaxSettings.ajaxData.data.push(settings.data);
                if( typeof ( settings.success ) == "function" )
                    {
                        this.ajaxSettings.onSuccess.push(settings.success);
                    }
                if( typeof ( settings.error ) == "function" )
                    {
                        this.ajaxSettings.onError.push(settings.error);
                    }
                window.clearTimeout(this.ajaxTimeout);
                this.ajaxTimeout=window.setTimeout(
                    function()
                    {
                        ( function( ajaxSettings )
                            {
                                var settings        =_.extend({}, ajaxSettings);
                                settings.url        ="/ajax/";
                                settings.type       =settings.type || "post";
                                settings.dataType   =settings.dataType || "json";
                                settings.data       =settings.ajaxData || {};
                                settings.data.isAjax=true;
                                settings.success    =function( response )
                                    {
                                        if( typeof ( response.message ) != "undefined" )
                                            {
                                                if( typeof ( response.message.type ) != "undefined" )
                                                    {
                                                        if( response.message.type == "header" )
                                                            {
                                                                // showHeaderMessage(response.message.message, response.message.status,
                                                                // response.message.delay);
                                                            }
                                                    }
                                            }
                                        for( var i=0; i < settings.onSuccess.length; i++ )
                                            {
                                                if( typeof ( settings.onSuccess[ i ] ) == "function" )
                                                    {
                                                        settings.onSuccess[ i ](response);
                                                    }
                                            }
                                    };
                                settings.error      =function( jqXHR, textStatus, errorThrown )
                                    {
                                        for( var i=0; i < settings.onError.length; i++ )
                                            {
                                                if( typeof ( settings.onError[ i ] ) == "function" )
                                                    {
                                                        settings.onError[ i ](jqXHR, textStatus, errorThrown);
                                                    }
                                            }
                                    };
                                $.ajax(settings);
                                self.resetAjaxSettings();
                            } )(self.ajaxSettings);
                    },
                    100,
                );
            };

        this.init();
    };
//отслеживаем клик на ссылки. включаем загрузку
document.addEventListener("click", function( el )
{
    if(el.path && typeof el.path.forEach !== 'undefined' )
        {
            el.path.forEach(element=>{
                if(element.getAttribute && element.getAttribute("data-loadonclick") !== null){
                    window.App.setLoader();
                }
            })
        }



});
window.Xpage=new XpageInit();

window.dateMask =new Inputmask("99.99.9999");
window.phoneMask=new Inputmask("+7 (999) 99-99-999");

function number_format( number, decimals, dec_point, thousands_sep )
    {
        var i, j, kw, kd, km;
        if( isNaN(decimals=Math.abs(decimals)) )
            {
                decimals=2;
            }
        if( dec_point == undefined )
            {
                dec_point=",";
            }
        if( thousands_sep == undefined )
            {
                thousands_sep=".";
            }
        i =parseInt(number=( +number || 0 ).toFixed(decimals)) + "";
        kw=i.split(/(?=(?:\d{3})+$)/).join(thousands_sep);
        kd=( decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "" );
        return kw + kd;
    }

function pluralize( number, words )
    {
        let n=Math.abs(number);
        n%=100;
        if( n >= 5 && n <= 20 )
            {
                return words[ 2 ];
            }
        n%=10;
        if( n === 1 )
            {
                return words[ 0 ];
            }
        if( n >= 2 && n <= 4 )
            {
                return words[ 1 ];
            }
        return words[ 2 ];
    }

Vue.filter("phoneFormat", phone =>
{
    phone=phone.replace(/[^\d]/g, "");
    if( phone.length != 11 )
        {
            return phone;
        }
    return phone.replace(/\d(\d{3})(\d{3})(\d{2})(\d{2})/, "8-$1-$2-$3-$4");
});

Vue.filter("plural", function( value, words )
{
    return pluralize(value, words);
});

Vue.filter("numberFormat", function( value )
{
    return number_format(value, 0, ".", " ");
});

Vue.filter("priceFormat", function( value )
{
    return number_format(value, 0, ".", " ");
});

import CitySelect from "./components/CitySelect.vue";

Vue.component("city-select", CitySelect);

import HeaderSearch from "./components/HeaderSearch.vue";

Vue.component("header-search", HeaderSearch);

import Basketline from "./components/Basketline.vue";

Vue.component("basketline", Basketline);

import Quantity from "./components/Quantity.vue";

Vue.component("quantity", Quantity);

import Product from "./components/Product.vue";

Vue.component("product", Product);

import OrderOneClick from "./components/OrderOneClick.vue";

Vue.component("order-one-click", OrderOneClick);

// import ProductAddedPopup from './components/ProductAddedPopup.vue';
// Vue.component('product-added-popup', ProductAddedPopup);


// import LotteryShopsMap from './components/LotteryShopsMap.vue';
// Vue.component('lottery-shops-map', LotteryShopsMap);


// import Bonuses from './components/Bonuses.vue';
// Vue.component('bonuses', Bonuses);


// import ForgotPassword from './components/ForgotPassword.vue';
// Vue.component('forgot-password', ForgotPassword);
//
//
//
//
// import OrdersHistory from './components/OrdersHistory.vue';
// Vue.component('orders-history', OrdersHistory);

// import AlreadyRegisteredPopup from './components/AlreadyRegisteredPopup.vue';
// Vue.component('already-registered-popup', AlreadyRegisteredPopup);
//
// import ServiceShopsPopup from './components/ServiceShopsPopup.vue';
// Vue.component('service-shops-popup', ServiceShopsPopup);
//
// import ServiceAddToCartPopup from './components/ServiceAddToCartPopup.vue';
// Vue.component('service-add-to-cart-popup', ServiceAddToCartPopup);

Vue.component("popup", () => import("./components/Popup.vue"));
Vue.component("input-password", () => import("./components/InputPassword.vue"));
Vue.component("input-phone", () => import("./components/InputPhone.vue"));
Vue.component("input-date", () => import("./components/InputDate.vue"));
Vue.component("input-mask", () => import("./components/InputMask.vue"));
Vue.component("input-file", () => import("./components/InputFile.vue"));
Vue.component("cooler-gift-calc", () => import("./components/CoolerGiftCalc.vue"));
Vue.component("kuler-v-podarok", () => import("./components/KulerVPodarok.vue"));
Vue.component("discount-select", () => import("./components/DiscountSelect.vue"));
Vue.component("confirm-popup", () => import("./components/ConfirmPopup.vue"));
Vue.component("empty-to-full-form", () => import("./components/EmptyToFullForm.vue"));
Vue.component("bonus-card", () => import("./components/BonusCard.vue"));
Vue.component("phone-confirm", () => import("./components/PhoneConfirm.vue"));
Vue.component("bonus-liters-products", () => import("./components/BonusLitersProducts.vue"));
Vue.component("catalog-filter", () => import("./components/CatalogFilter.vue"));
Vue.component("product-shops", () => import("./components/ProductShops.vue"));
Vue.component("product-tabs", () => import("./components/ProductTabs.vue"));
Vue.component("order-form", () => import("./components/OrderForm.vue"));
Vue.component("cart", () => import("./components/Cart.vue"));
Vue.component("cart-small", () => import("./components/CartSmall.vue"));
Vue.component("cart-small-short", () => import("./components/CartSmallShort.vue"));
Vue.component("shops-list", () => import("./components/ShopsList.vue"));
Vue.component("orders-history", () => import("./components/OrdersHistory.vue"));
Vue.component("act-of-reconciliation-order", () => import("./components/ActOfReconciliationOrder.vue"));
Vue.component("registration-form", () => import("./components/RegistrationForm.vue"));
Vue.component("forgot-password", () => import("./components/ForgotPassword.vue"));
Vue.component("catalog", () => import("./components/Catalog.vue"));
Vue.component("vacancy-list", () => import("./components/VacancyList.vue"));
Vue.component("balance", () => import("./components/Balance.vue"));
Vue.component("resume-form", () => import("./components/ResumeForm.vue"));
Vue.component("auth-by-number", () => import("./components/AuthByNumber.vue"));
Vue.component("auth-by-login", () => import("./components/AuthByLogin.vue"));
Vue.component("loader", () => import("./components/Loader.vue"));
Vue.component("personal-profile-form", () => import("./components/Profile/PersonalProfileForm.vue"));
Vue.component("change-password-form", () => import("./components/Profile/ChangePasswordForm.vue"));

Vue.component("draggable", () => import("vuedraggable"));

if( window.frameCacheVars !== undefined )
    {
        BX.addCustomEvent("onFrameDataReceived", function( json )
        {
            afterCompositeLoaded();
        });
    }
else
    {
        if( window.BX )
            {
                BX.ready(() =>
                {
                    afterCompositeLoaded();
                });
            }
        else
            {
                $(function()
                {
                    afterCompositeLoaded();
                });
            }
    }

function onCompositeFail()
    {
        if( ~window.location.href.indexOf("?") )
            {
                window.location.href=window.location.href + "&ncc=1";
            }
        else
            {
                window.location.href=window.location.href + "?ncc=1";
            }
    }

BX.addCustomEvent("onFrameDataRequestFail", function( response )
{
    onCompositeFail();
});
if( !~window.location.href.indexOf("ncc=1") )
    {
        window.compositeFailTimeout=setTimeout(
            function()
            {
                onCompositeFail();
            },
            5000,
        );
    }

function afterCompositeLoaded()
    {
        clearTimeout(window.compositeFailTimeout);
        window.App=new Vue({
            store,
            el       : ".app",
            data     : {
                catalogClass : {
                    catalog : true,
                    loading : false,
                },
            },
            computed : {
                cities()
                    {
                        return this.$store.state.initialData.cities || [];
                    },
                deviceType()
                    {
                        return this.$store.state.initialData.deviceType || "";
                    },
                domains()
                    {
                        return this.$store.state.initialData.domains || [];
                    },
                domainData()
                    {
                        if( !this.domains.length )
                            {
                                return {};
                            }
                        let host=location.host;
                        let data=this.domains.find(d => d.CODE == location.host);
                        if( !data )
                            {
                                data=this.domains.find(d => d.CODE == "l-w.ru") || {};
                            }
                        return data;
                    },
                iosLink()
                    {
                        return this.$store.state.initialData.iosLink;
                    },
                androidLink()
                    {
                        return this.$store.state.initialData.androidLink;
                    },
                mobileAppLink()
                    {
                        return is.ios() ? this.iosLink : this.androidLink;
                    },
                userData()
                    {
                        return this.$store.state.initialData.userData || {};
                    },
                openedPopup : () => store.state.openedPopup,
                cartCount   : () => store.state.cartCount,
                selectedCityId()
                    {
                        return +this.$store.state.selectedCityId || 0;
                    },
                cityName()
                    {
                        if (!this.cities.length) {
                            return '';
                        }
                        if( this.selectedCityId )
                            {
                                let city=this.cities.find(c => c.ID == this.selectedCityId);
                                if( !city )
                                    {
                                        city = this.cities[ 0 ] || {};
                                    }
                                return city.NAME || '';
                            }
                        return '';
                    },
                cartDeliverySum () {
                    let deliverySum = 0,
                        cityName = this.cityName || 'Челябинск',
                        deliveryPayment = (this.$store.state.initialData.deliveryPayments || []).find(o => o.UF_CITY == cityName ),
                        cartItems = (this.$store.state.cart.items || []),
                        quantity;
                    if (deliveryPayment) {
                        let deliveryGroups = [
                            // предоплаченная вода
                            cartItems.filter( item => ~[ 19000 ].indexOf(+item.volume) && item.bonusType == 'prepay' && !~[175, 180,].indexOf(+item.price)),
                            // вода со скидкой
                            cartItems.filter( item => item.bonusType == 'discount' && item.price == 0 && ~[12000, 19000,].indexOf(+item.volume) ),
                        ];
                        for (var i = 0; i < deliveryGroups.length; i++) {
                            if (deliveryGroups[i].length) {
                                quantity = deliveryGroups[i].map(o => +o.quantity).reduce((a,b)=> a+b, 0);
                                if (this.userData.isUserPricesEnabled && quantity > 1 && deliveryPayment.UF_PRICE_TWO_2HOUR) {
                                    deliverySum += quantity * +deliveryPayment.UF_PRICE_TWO_2HOUR;
                                }
                                else if (this.userData.isUserPricesEnabled && deliveryPayment.UF_PRICE_ONE_2HOUR) {
                                    deliverySum += quantity * +deliveryPayment.UF_PRICE_TWO_2HOUR;
                                }
                                else if (quantity > 1 && deliveryPayment.UF_PRICE_TWO) {
                                    deliverySum += quantity * +deliveryPayment.UF_PRICE_TWO;
                                }
                                else if (deliveryPayment.UF_PRICE_ONE) {
                                    deliverySum += quantity * +deliveryPayment.UF_PRICE_ONE;
                                }
                            }
                        }
                    }
                    deliverySum = Math.ceil(deliverySum);
                    return deliverySum;
                },
            },
            mounted()
                {
                    this.$store.dispatch("loadInitData");
                    if( typeof ( window.onVueMounted ) == "function" )
                        {
                            setTimeout(() =>
                            {
                                window.onVueMounted();
                            }, 1000);
                        }

                    if( window.lwMessage )
                        {
                            this.alert(window.lwMessage.message, window.lwMessage.status, +window.lwMessage.delay ? +window.lwMessage.delay / 1000 : 3);
                        }

                    if (window.location.pathname == '/') {
                        this.VKRetargetingProductEvent('view_home', {});
                    }
                    else if (
                        !~window.location.pathname.indexOf('/catalog/')
                    ) {
                        this.VKRetargetingProductEvent('view_other', {});
                    }

                    if( $("#vacancy-video").length )
                        {
                            setTimeout(() =>
                            {
                                $.fancybox({
                                    href : "#vacancy-video",
                                });
                            }, 1000);
                        }
                    let formPropIds={
                        "name"  : [
                            93,
                            97,
                            105,
                            113,
                            207,
                            346,
                        ],
                        "phone" : [
                            94,
                            98,
                            106,
                            114,
                            208,
                            347,
                        ],
                        "email" : [
                            99,
                            107,
                            115,
                            209,
                        ],
                        "city"  : [
                            100,
                            359,
                        ],
                    };
                    for( var fieldType in formPropIds )
                        {
                            if( formPropIds.hasOwnProperty(fieldType) )
                                {
                                    for( var i=0; i < formPropIds[ fieldType ].length; i++ )
                                        {
                                            if( $(`[name="PROPERTY[${formPropIds[ fieldType ][ i ]}][0]"]`).length )
                                                {
                                                    $(`[name="PROPERTY[${formPropIds[ fieldType ][ i ]}][0]"]`).each(( key, input ) =>
                                                    {
                                                        if( this.userData[ fieldType ] )
                                                            {
                                                                if( !input.value )
                                                                    {
                                                                        input.value=this.userData[ fieldType ];
                                                                    }
                                                            }
                                                        else if( fieldType == "city" )
                                                            {
                                                                input.value=this.cityName;
                                                            }
                                                    });
                                                }
                                        }
                                }
                        }

                    moment.now=() =>
                        {
                            return +( new Date ) - ( +store.state.timeOffset || 0 );
                        };

                    $("address.phone").each(function()
                    {
                        var phone=$(this).text().replace(/[^\d]/g, "");
                        $(this).wrapInner("<a href=\"tel:" + phone + "\"></a>");
                    });

                    if( document.querySelector("#route-scheme-map") )
                        {
                            this.initMap(() =>
                            {
                                ymaps.ready(() =>
                                {
                                    var map=new ymaps.Map("route-scheme-map", {
                                        center : [55.015010, 61.211537],
                                        zoom   : 12,
                                    });
                                    map.controls.add(
                                        new ymaps.control.ZoomControl(),
                                    );
                                    map.controls.add("typeSelector");
                                    var geoObjects=[];
                                    var placemark =new ymaps.Placemark(
                                        [55.015010, 61.211537],
                                        {},
                                        {
                                            iconLayout      : "default#image",
                                            iconImageHref   : "/local/templates/.default/src/img/ico-marker.svg",
                                            iconImageSize   : [37, 53],
                                            iconImageOffset : [-18, -53],
                                        },
                                    );
                                    geoObjects.push(placemark);
                                    map.geoObjects.add(placemark);
                                });
                            });
                        }

                    $(document).on("yacounter25446128inited", () =>
                    {
                        if( Cookies.get("yaReachGoal") )
                            {
                                if( typeof ( window.yaCounter25446128 ) != "undefined" )
                                    {
                                        window.yaCounter25446128.reachGoal(Cookies.get("yaReachGoal"));
                                        Cookies.remove("yaReachGoal", {path : "/"});
                                    }
                            }
                    });

                    moment.locale("ru");

                    this.initRecaptcha().then((grecaptcha) => {
                        /*if(!this.$store.state.token)
                        {
                            grecaptcha.execute(this.$store.state.initialData.recaptchaSiteKey, {action : "sms"})
                            .then(( token ) => this.$store.dispatch("setToken", token));
                        }*/
                        $(document).on('click touch mouseover', 'form', e => {
                            let inputToken = e.currentTarget.querySelector("[name=\"recaptcha_token\"]");
                            if (!inputToken) {
                                return;
                            }
                            let action = inputToken.getAttribute("data-action-id");
                            if(!inputToken.value && !inputToken.classList.contains("recaptcha-processed"))
                            {
                                inputToken.classList.add("recaptcha-processed");
                                grecaptcha.execute(this.$store.state.initialData.recaptchaSiteKey, {
                                    action
                                }).then(token => inputToken.value = token);
                            }
                        });
                    });

                    $("a[href$=\".mp3\"], a[href$=\".wav\"]").each(function()
                    {
                        var elAudio=document.createElement("audio");
                        elAudio.setAttribute("controls", true);
                        var elSource     =document.createElement("source");
                        var src          =$(this).attr("href");
                        // получаем расширение файла регуляркой из аттрибута href
                        var fileExtension=src.replace(/.*\.([^\.]*)$/, "$1");
                        elSource.setAttribute("type", "audio/" + fileExtension);
                        elSource.setAttribute("src", src);
                        elAudio.appendChild(elSource);
                        $(this).replaceWith(elAudio);
                    });

                },
            methods  : {
                refreshCaptchaTokenForSms()
                {
                    return new Promise(resolve => {
                        grecaptcha.execute(this.$store.state.initialData.recaptchaSiteKey).then(
                          token => {
                              this.$store.dispatch('setToken', token);
                              resolve(token);
                          }
                        );
                    });
                },
                metrikaReachGoal (goalId) {
                    if( typeof ( window.yaCounter25446128 ) != "undefined" )
                    {
                        window.yaCounter25446128.reachGoal(goalId);
                    }
                },
                VKRetargetingProductEvent (event, data = {}) {
                    setTimeout(() => {
                        if (
                            (VK || {}).Retargeting &&
                            this.$store.state.initialData.vkPriceListId
                        ) {

                            VK.Retargeting.ProductEvent(
                                this.$store.state.initialData.vkPriceListId,
                                event,
                                data
                            );
                        }
                    }, 1000);
                },
                setLoader (visible = true) {
                    if (visible) {
                        document.body.classList.add('loading');
                    }
                    else {
                        document.body.classList.remove('loading');
                    }
                },
                openOrderOneClickPopup()
                    {
                        if( ( this.$store.state.cart.items || [] ).length )
                            {
                                this.$refs.OrderOneClickPopup.open();
                            }
                        else
                            {
                                this.alert("<a href=\"/catalog/\">Добавьте пожалуйста товар в корзину</a>", "error");
                            }
                    },
                initMap( callback )
                    {
                        return new Promise(resolve =>
                        {
                            if( !window.ymaps )
                                {
                                    var script   =document.createElement("script");
                                    script.src   ="https://api-maps.yandex.ru/2.1/?lang=ru_RU";
                                    script.onload=() =>
                                        {
                                            ymaps.ready(() =>
                                            {
                                                resolve();
                                            });
                                        };
                                    document.body.appendChild(script);
                                }
                            else
                                {
                                    ymaps.ready(() =>
                                    {
                                        resolve();
                                    });
                                }
                        });
                    },
                initRecaptcha()
                    {
                        return new Promise((resolve, reject) => {
                            setTimeout(() => {
                                if (!this.$store.state.initialData.recaptchaSiteKey) {
                                    reject();
                                }
                                let script = document.createElement('script');
                                script.src ="https://www.google.com/recaptcha/api.js?render=" + this.$store.state.initialData.recaptchaSiteKey;
                                script.onload = () => {
                                    grecaptcha.ready(() => resolve(grecaptcha));
                                };
                                document.body.appendChild(script);
                            }, 2000);
                        });
                    },
                sendSmsCode( phone )
                    {
                        return new Promise(( resolve, reject ) =>
                        {
                            this.$root.refreshCaptchaTokenForSms().then(
                              (token) =>
                              {
                                    phone=phone.replace(/[^\d]/g, "");
                                    let formData = new FormData();

                                      if(token == ""){
                                          formData.append('token',this.$store.state.token);
                                      }else{
                                          formData.append('token', token);
                                      }

                                      //formData.set('token', this.$store.state.token);
                                    fetch(`/api/v1/send-sms-code/${phone}/`, {
                                        body: formData,
                                        method : "POST",
                                    })
                                        .then(res => res.json())
                                        .then(res =>
                                        {
                                            if(res.message)
                                            {
                                                this.$root.alert(res.message,'error');
                                            }
                                            //this.refreshCaptchaTokenForSms();
                                            resolve(res);
                                        });
                              }
                            );
                        });
                    },
                productAddedPopup( text="" )
                    {
                        if( this.$refs.productAddedPopup )
                            {
                                this.$refs.productAddedPopup.show(text);
                            }
                        if( typeof ( window.yaCounter25446128 ) != "undefined" )
                            {
                                window.yaCounter25446128.reachGoal("PRODUCT_ADDED_TO_CART");
                            }
                    },
                alert( msg, status="success", sleep = 1.5 )
                    {
                        alertify.notify(msg, status,sleep,function(  ){
                            //удаление элемента после окончания уведомления
                            let doc = document.querySelector('.alertify-notifier');
                            if(doc)
                                {
                                    doc.remove();
                                }
                        });
                    },
                showMessage( message )
                    {
                        if( !message )
                            {
                                return;
                            }
                        return new Promise(( resolve, reject ) =>
                        {
                            this.message          =message;
                            let popupCheckInterval=setInterval(() =>
                            {
                                if( this.$refs.Popup )
                                    {
                                        clearInterval(popupCheckInterval);
                                        this.$refs.Popup.open()
                                            .then(action =>
                                            {
                                                resolve(action);
                                            });
                                    }
                            }, 1000);
                        });
                    },
                showMessages(arMessages, status="success", sleep = 5)
                {
                    let message = "";
                    for (let ind in arMessages) {
                        if (message != "") {
                            //message += "\n";
                            message += "<br/>";
                        }
                        message += arMessages[ind].message
                    }
                    this.alert(message, status, sleep);
                },
                cookiesGet( name )
                    {
                        return Cookies.get(name);
                    },
                cookiesSet( name, val )
                    {
                        Cookies.set(name, val, {expires : 30});
                    },
                cookie( name, val, options={} )
                    {
                        if( typeof ( val ) == "undefined" )
                            {
                                return Cookies.get(name);
                            }
                        else
                            {
                                Cookies.set(name, val, Object.assign({expires : 30}, options));
                            }
                    },
                formatPrice( number, decimals, dec_point, thousands_sep )
                    {
                        var i, j, kw, kd, km;

                        if( isNaN(decimals = Math.abs(decimals)) ){
                            decimals = 2;
                        }
                        if( dec_point == undefined ){
                            dec_point = ".";
                        }
                        if( thousands_sep == undefined ){
                            thousands_sep = " ";
                        }

                        i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

                        if( (j = i.length) > 3 ){
                            j = j % 3;
                        } else{
                            j = 0;
                        }

                        km = (j ? i.substr(0, j) + thousands_sep : "");
                        kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
                        kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

                        return km + kw + kd;
                },
                priceRound(number)
                    {
                        return number % 1 === 0 ? number : parseFloat(number.toFixed(2));
                    },
                saveDiscountType (discountType) {
                    return new Promise((resolve, reject) => {
                        if (!discountType) {
                            reject();
                        }
                        else {
                            let formData = new FormData();
                            formData.append('discount', discountType);
                            fetch("/api/v1/discount/save/",{
                                method : 'POST',
                                body : formData
                            }).then(r => r.json()).then(result => {
                                if (result.message) {
                                    this.$root.alert(result.message, result.success?'success':'error');
                                }
                                if (result.success) {
                                    this.$emit('discountTypeSaved');
                                }
                                resolve(result);
                            });
                        }
                    });
                },
                changeFile(formats)
                {
                    let allowExp = [];
                    if(formats!=""){
                        allowExp = formats.split(", ");
                    }
                    let fileInput = event.target;
                    if (fileInput && fileInput.files.length && fileInput.files[0]) {
                        Array.from(fileInput.files).forEach((file) => {
                                if (file.size > 15 * 1024 * 1024) {
                                    this.$root.alert("Размер файла более 15 Мб.", 'error');
                                    fileInput.value = '';
                                }else{
                                    let parts = file.name.split('.');
                                    if (!allowExp.includes(parts.pop())) {
                                        this.$root.alert('Формат документа "'+ parts.pop() +'" не соответствует возможному для загрузки', 'error');
                                        fileInput.value = '';
                                    }
                                }

                            }
                        )
                    }
                },
                sendMainBoxItem(str)
                    {
                        if(str){
                            let script = document.createElement("script");
                            script.textContent = str;
                            document.body.appendChild(script);
                        }
                    }
            },
            watch    : {
                userData : {
                    deep : true,
                    handler( userData )
                        {
                            if( +userData.id )
                                {
                                    if( !this.cookie("lk-head-block-showed") )
                                        {
                                            let elHeadLc=document.querySelector("header .head-lc");
                                            elHeadLc.classList.add("expanded");
                                            setTimeout(() =>
                                            {
                                                elHeadLc.classList.remove("expanded");
                                            }, 5000);
                                            this.cookie("lk-head-block-showed", 1);
                                        }
                                    if (userData.discountType === '' && this.$refs.discountTypePopup) {
                                        this.$refs.discountTypePopup.open();
                                    }
                                }
                        },
                },
            },
        });
    }

const RECAPTCHA_ERROR_CODES = [50020, 50021, 50022];

export const isRecaptchaError = (code) => RECAPTCHA_ERROR_CODES.includes(code);